/** @jsxImportSource @emotion/react */
import {
  EuiPageTemplate,
  EuiText,
  EuiSpacer,
  EuiFlexItem,
  EuiFlexGrid,
} from "@inscopix/ideas-eui";
import ModalCloneProject from "components/ModalProject/ModalCloneProject";
import { useGetDemoProjects } from "hooks/useGetProjects";
import { isUndefined } from "lodash";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { useCallback, useState } from "react";
import { isDefined } from "utils/isDefined";
import { DemoProjectCard } from "./DemoProjectCard";
import { css } from "@emotion/react";

export const DemoProjects = () => {
  const { demoProjects } = useGetDemoProjects();
  const hasInternalPersonalSpaceOrTenant = useUserContext(
    (s) =>
      (s.personalSpace !== undefined && !s.personalSpace.isExternal) ||
      s.tenants.length > 0,
  );

  const [selectedProjectIdToCopy, setSelectedProjectIdToCopy] = useState<{
    id: string;
  }>();
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);

  const copyProject = useCallback((projectId: string) => {
    setSelectedProjectIdToCopy({ id: projectId });
    setIsCopyModalVisible(true);
  }, []);

  if (isUndefined(demoProjects) || demoProjects.length === 0) {
    return null;
  }

  return (
    <EuiPageTemplate.Section color={"subdued"}>
      <EuiText size="s">
        <h2>Try out a demo project!</h2>
      </EuiText>
      <EuiSpacer size="m" />
      <EuiFlexGrid
        gutterSize="l"
        css={css`
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        `}
      >
        {demoProjects
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((project) => (
            <EuiFlexItem
              key={project.id}
              css={css`
                max-width: 400px;
              `}
            >
              <DemoProjectCard
                project={project}
                copyProject={copyProject}
                hasInternalPersonalSpaceOrTenant={
                  hasInternalPersonalSpaceOrTenant
                }
              />
            </EuiFlexItem>
          ))}
      </EuiFlexGrid>

      {isCopyModalVisible && isDefined(selectedProjectIdToCopy) && (
        <ModalCloneProject
          onClose={() => setIsCopyModalVisible(false)}
          projectId={selectedProjectIdToCopy.id}
        />
      )}
    </EuiPageTemplate.Section>
  );
};
